import React, { useState } from 'react';
import { Button, Typography, Paper, IconButton, Modal, Box, LinearProgress } from '@mui/material';
import Grid from "@mui/material/Grid2";
import "./operationsStyles.scss";
import { DateInputLeftLabel } from 'src/shared/components/date_picker_component';
import { SelectLeftLabel } from 'src/shared/components/select_list_component';
import Swal from "sweetalert2";
import { useNavigate } from 'react-router-dom';
import { InputCustomSearchLargeNumber } from 'src/shared/components/input_search_large_numbe';

export const AgileView = () => {

  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  const [typeOfSearch, setTypeOfSearch] = useState<string | null>(null);

  const [step, setStep] = useState("selectDateRange")

  const [loading, setLoading] = useState(false)

  const [inputValueFilter, setInputValueFilter] = useState<string>("");

  const navigate = useNavigate();

  const handleRequestData = () => {

    const messageWithErrors = []

    if (!startDate || startDate === null) {
      messageWithErrors.push("Se requiere agregar una fecha Inicio")
    }

    if (!endDate || endDate === null) {
      messageWithErrors.push("Se requiere agregar una fecha Fin")
    }

    if (new Date(startDate as string) > new Date(endDate as string)) {
      messageWithErrors.push("La fecha de inicio no puede ser posterior a la fecha de fin")
    }

    if (!typeOfSearch && typeOfSearch !== "") {
      messageWithErrors.push("Se requiere agregar un tipo de búsqueda")
    }

    if (messageWithErrors.length > 0) {
      Swal.fire({
        title: "Error",
        html: `<p>No se puede continuar debido a los siguientes errores:</p><ul>${messageWithErrors.map(error => `<li>${error}</li>`).join('')}</ul>`,
        icon: "error",
        confirmButtonText: "Aceptar",
      })
      return
    }

    // Determinar la ruta según el tipo de búsqueda
    let baseUrl: string;
    if (typeOfSearch === "Pictures") {
      baseUrl = `/gto/pictures_agile_view/${encodeURIComponent(startDate!)}/${encodeURIComponent(endDate!)}/${encodeURIComponent(typeOfSearch!)}`;
    } else {
      baseUrl = `/gto/operations_summary/${encodeURIComponent(startDate!)}/${encodeURIComponent(endDate!)}/${encodeURIComponent(typeOfSearch!)}`;
    }
    const queryParams = inputValueFilter ? `?locations=${encodeURIComponent(inputValueFilter)}` : '';
    navigate(`${baseUrl}${queryParams}`);

  }

  return (
    <>
      {loading && (
        <>
          <Box className="modal_analyst_loading_background" />
          <Box className="modal__analyst_task_loading">
            <LinearProgress />
            Consultando....
          </Box>
        </>
      )}
      <Grid container className="operations-container" spacing={2} justifyContent="center">

        <Paper className="operations-paper" elevation={2}>
          <Typography className="operations-title" sx={{ fontSize: 16, fontWeight: 600 }}>
            SELECCIONAR RANGO DE FECHA
          </Typography>
          <Grid className="operations-fields">
            <DateInputLeftLabel
              label="Fecha Inicio"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              onClear={() => setStartDate('')}
            />
            <DateInputLeftLabel
              label="Fecha Fin"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              onClear={() => setEndDate('')}
            />
          </Grid>
          <Grid container spacing={2} alignItems="center" justifyContent="center" className="operations-fields">
            <Grid
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <SelectLeftLabel
                label="Tipo de Búsqueda"
                value={typeOfSearch}
                options={[
                  { value: 'Pictures', label: 'Fotos', description: 'Este reporte es usado para evaluuar fotos en un periodo de tiempo' },
                  { value: 'Rendimientos', label: 'Rendimientos', description: 'Este reporte es usado para analizar los rendimientos de las operaciones, se parte de la fecha de inicio de actividades de campo y desde esas se parte para realizar la relacion de analisis (considerar que normnalmente analisis llevan 1 dia de demora)' },
                  {
                    value:
                      'Relación de análisis', label: 'Relación de análisis',
                    description: 'Este reporte es usado para evaluar los analisis realizados en un periodo de tiempo, aqui se pueden ver los analisis en la fecha pautada (las actividades de campo involucradas pueden ser de fechas previa a la fecha de inicio)'
                  },
                  {
                    value: 'Requerimientos', label: 'Requerimientos',
                    description: 'Este reporte es usado para evaluar los requerimientos generados en un periodo de tiempo, aqui se pueden ver los requerimientos generados en la fecha pautada (las actividades de campo involucradas pueden ser de fechas previa a la fecha de inicio)'
                  },
                  {
                    value: 'Secuencia', label: 'Secuencia',
                    description: 'Este reporte es usado para mostrar la secuencia de las operaciones, en este reporte se cuentran los pozos cuya fecha de inicio o fin se encuentra en el periodo (las fecha de programa en algunos casos pueden ser previas a la fecha de inicio)'
                  },
                ]}
                onChange={(e) => setTypeOfSearch(e.target.value)}
                onClear={() => setTypeOfSearch(null)}
              />
            </Grid>
          </Grid>
          {typeOfSearch === "Pictures" && (
            <Grid container spacing={2} alignItems="center" justifyContent="center" className="operations-fields">
              <InputCustomSearchLargeNumber
                label='Locación(es)'
                value={inputValueFilter}
                onChange={(value) => setInputValueFilter(value)}
                maxNumber={10}
              />
            </Grid>
          )}

          <Grid container justifyContent="center" className="operations-fields">
            <Button variant="contained" className="operations-btn" onClick={handleRequestData}>
              BUSCAR
            </Button>
          </Grid>
        </Paper>
      </Grid>
    </>
  )
};